import { Component, Input, OnChanges } from "@angular/core";
import { StatsNormalizerService } from "../../stats-normalizer/stats-normalizer.service";
import { sum } from "../../utils/sum";

@Component({
  selector: "ab-apdex-card",
  templateUrl: "./apdex-card.component.html",
})
export class ApdexCardComponent implements OnChanges {
  @Input() public routesStats: any;
  @Input() public statusCode: any;
  @Input() public project: any;
  @Input() public dur: string;
  @Input() public lastN: number;
  @Input() public loading: boolean;

  public apdexScore: number;
  public apdexScoreList: number[];
  private RESPONSE_KEYS = [
    "success",
    "redirection",
    "clientError",
    "serverError",
  ];

  constructor(private statsNormalizerService: StatsNormalizerService) {}

  public ngOnChanges() {
    if (
      !this.routesStats ||
      this.routesStats.total.count[0] === undefined ||
      !this.statusCode ||
      this.project.apdexThreshold === 0
    ) {
      return;
    }

    this.apdexScore = this.calculateApdexScore();
    this.apdexScoreList = this.calculateApdexScoreList();
  }

  private calculateApdexScoreList() {
    const satisfactionLevelCounts = {
      satisfied: [] as number[],
      tolerating: [] as number[],
      frustrated: [] as number[],
    } as any;

    const listLength = this.routesStats.time.length;

    for (const satisfactionLevel of Object.keys(satisfactionLevelCounts)) {
      for (let i = 0; i < listLength; i++) {
        satisfactionLevelCounts[satisfactionLevel].push(
          this.statusCode[satisfactionLevel][i] || 0,
        );
      }
    }

    const apdexScoreList = [] as number[];

    for (let i = 0; i < listLength; i++) {
      const total =
        satisfactionLevelCounts.satisfied[i] +
        satisfactionLevelCounts.tolerating[i] +
        satisfactionLevelCounts.frustrated[i];

      let apdexScore = 0;
      if (total > 0) {
        apdexScore =
          (satisfactionLevelCounts.satisfied[i] +
            satisfactionLevelCounts.tolerating[i] / 2) /
          total;
      }

      apdexScoreList.push(apdexScore);
    }

    return this.statsNormalizerService.populateEmptyDaysWithZeros(
      apdexScoreList,
      this.routesStats.time,
      this.dur,
      this.lastN,
    );
  }

  private calculateApdexScore() {
    let satisfied = 0;
    let tolerating = 0;
    let frustrated = 0;

    for (const key of this.RESPONSE_KEYS) {
      satisfied += sum(this.routesStats[key].satisfied);
      tolerating += sum(this.routesStats[key].tolerating);
      frustrated += sum(this.routesStats[key].frustrated);
    }
    const total = satisfied + tolerating + frustrated;

    return (satisfied + tolerating / 2) / total;
  }
}
